import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';
import { isNull } from '@/functions/Util';

export default class RotaValidation extends DefaultValidation {
    validate(model, refs, root) {
        let validated = true;
        
        if (isNull(model.idrotaerp)) {
            refs.idrotaerpInput.focusedOut = true;
            validated = false;
        }
        if (isNull(model.descricao)) {
            refs.descricaoInput.focusedOut = true;
            validated = false;
        }
        if (isNull(model.idusuario)) {
            refs.promotorSelect.focusedOut = true;
            validated = false;
        }

        // if (dias) {
        //     dias.forEach((e, i) => {
        //         if (e.lpss && i < model.periodo) {
        //             e.lpss.forEach(l => {
        //                 if (l.situacao == 0) {
        //                     this.showMessage(new Message('alert', 'msg-rotas-inativas', true));
        //                     return validated = false;;
        //                 } else {
        //                     if (l.contratos) {
        //                         if (l.contratos.length == 0) {
        //                             console.error(`Falha na validação de rota no dia [${e.dataatendimento.toLocaleDateString()}] na LPS [${l.nome}] por não conter contratos.`);
        //                             this.showMessage(new Message('alert', 'msg-lps-sem-contrato-rota', true));
        //                             return validated = false;;
        //                         }
        //                     } else {
        //                         console.error(`Falha na validação de rota no dia [${e.dataatendimento.toLocaleDateString()}] na LPS [${l.nome}] por não conter contratos.`);
        //                         this.showMessage(new Message('alert', 'msg-lps-sem-contrato-rota', true));
        //                         return validated = false;;
        //                     }
        //                     l.contratos.forEach(c => {
        //                         if (c.proContratoLps.replicapda != 3) {
        //                             this.showMessage(new Message('alert', 'msg-rotas-inativas', true));
        //                             return validated = false;;
        //                         }
        //                     })
        //                 }
        //             });
        //         }
        //     });
        // }

        if (!validated) {
            root.msgs.push(new Message('alert', 'msg-campos-obrigatorios', true));
        }

        return validated;
    }
}
